<template>
  <div class="home-page--banner">
    <div  class="home-page--banner-container">
      <div class="home-page--banner-description">
        <h3 class="home-page--banner-description-heading"><a href="https://hakkoda.io/resources/hakkoda-an-ibm-company/" class="home-page--banner-secondary-title">Bigger Platform, Same Mission: <span class="home-page--banner-primary-title">Hakkōda, an IBM Company</span> </a> <a href="https://hakkoda.io/resources/hakkoda-an-ibm-company/" class="home-page--banner-cta"> Read more ></a></h3>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { onMounted, onUnmounted } from 'vue'

  interface Props {
  }

  const props = defineProps<Props>()

  onMounted( ()  => {
  })

  onUnmounted( () => {
  })
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .home-page--banner {
    background-color: #17191d;
    display: flex;
    justify-content: center;
    align-items: center;

    @media (min-width: 768px) {
      position: absolute;
      width: 100%;
    }

    &-container {
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      gap: 20px;
      padding: 0 20px;
    }

    &-logo {
      align-self: end;
      width: 135px;

      img {
        width: 134px;
        height: 48px;
        position: relative;
        top: 14px;
        min-width: 134px;

        @media (max-width: 767px) {
          position: initial;
          top: 0;
        }
      }

     
      @media (max-width: 767px) {
        align-self: center;
      }
    }

    &-description {
      display: flex;
      align-items: center;

      &-heading {
        padding: 10px 0;
        margin: 0;
        line-height: 11px; 
      }
    }

    h3 {
      color: #FFF;
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 18px;
      text-align: center;
    }

    &-primary-title {
      color: #00D5FF;
      font-size: 12px;
      line-height: 12px; 
      font-style: normal;
      font-weight: 500;      

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 18px; 
      }
    }

    &-secondary-title {
      color: #fff;
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 12px; 

      @media (min-width: 768px) {
        font-size: 18px;
        line-height: 18px; 
      }
    }

    &-cta {
      color: #fff;
      font-size: 11px;
      font-style: normal;
      font-weight: 700;
      line-height: 11px; 
      white-space: nowrap;

      @media (min-width: 768px) {
        font-size: 14px;
        line-height: 14px; 
      }
    }
  }
</style>